import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=0fe8fdae&scoped=true&"
var script = {}
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=0fe8fdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe8fdae",
  null
  
)

export default component.exports